module.exports = __webpack_public_path__ + "static/media/icon-general-medlooplogo.4895f489.svg";